module.exports = __webpack_public_path__ + "static/media/template-icon.bcddf0b7.svg";